module.exports = __webpack_public_path__ + "static/media/5.27174f51.mp3";